exports.CONTENT_PER_PAGE = 8;
exports.PAGE_PER_SCREEN = 4;

exports.POST = 'post';
exports.PORTFOLIO = 'portfolio';
exports.RESUME = 'resume';

// Site Information
exports.NAME = 'Jupiter.org Blog';
exports.TITLE = 'Jupiter.org Blog';
exports.PREFIX = 'Jupiter.org Blog ';
exports.DESCRIPTION = 'Blog educativo de tecnologia';
exports.AUTHOR = 'Juan Pablo de Jesus Figueroa Jaramillo';
exports.EMAIL = 'juanpablodejesus_figueroa@ucol.mx';
exports.KEYWORDS = [
  'Gatsby',
  'ReactJS',
].join(', ');
exports.SITE_URL = 'https://github.com/JuanPablo-Hack';
exports.PROFILE = 'https://avatars3.githubusercontent.com/u/42737121?s=200&v=4';

// Social
exports.GITHUB_ID = 'wonism';
exports.TWITTER_ID = 'j1ism';
exports.FACEBOOK_ID = 'j1.chic';
exports.LINKEDIN_ID = 'wonism';

// Disqus (Recommend you to use this)
exports.DISQUS_ID = 'sample';
